import React from 'react';

export const name = 'logout';

export const Logout = () => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    color="#161619"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.1841 3.65991L3.75759 3.65991L3.75759 21L11.1841 21"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="square"
      strokeLinejoin="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M18.4846 11.5138L10.9961 11.5138L10.9961 13.0138L18.49 13.0138L15.0444 16.4747L16.0319 17.4578L20.7135 12.7552C20.9845 12.483 20.984 12.0427 20.7124 11.7711L16.0308 7.08949L15.0455 8.07473L18.4846 11.5138Z"
      fill="currentColor"
    />
  </svg>
);
